import { ChangeEventHandler, VFC } from "react";
import { NumberDataField } from "src/types/data-field.types";
import { NodeData } from "src/types/node.types";
import { FormField } from "../form-field";
import { Input } from "./input";

export interface NumberFieldProps {
  field: NumberDataField;
  data: NodeData;
  onChange: (data: NodeData) => void;
}

export const NumberField: VFC<NumberFieldProps> = (props) => {
  const key = props.field.key;
  const onChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const valueAsNumber = e.target.valueAsNumber;
    const value = props.field.float ? valueAsNumber : Math.round(valueAsNumber);
    const valueOrUndefined = Number.isNaN(value) ? undefined : value;
    props.onChange({ ...props.data, [key]: valueOrUndefined });
  };

  const value = props.data[key] as number;

  return (
    <FormField.Field>
      <FormField.Label>{props.field.label}</FormField.Label>
      <FormField.Input>
        <Input
          style={{ width: "80px" }}
          type="number"
          defaultValue={value === undefined ? "" : value}
          onChange={onChange}
        />
      </FormField.Input>
    </FormField.Field>
  );
};
